export default Object.freeze([
  {text: '胖了', value: '+'},
  {text: '瘦了', value: '-'}
]);
